import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaMedicoPendencia.vue?vue&type=template&id=8ea902b2&scoped=true"
import script from "./ModalSolicitacaoCirurgiaMedicoPendencia.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaMedicoPendencia.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaMedicoPendencia.vue?vue&type=style&index=0&id=8ea902b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea902b2",
  null
  
)

export default component.exports